import { Injectable } from '@angular/core';
import {OrganizationData} from '../api/user-info-model';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class FilterStorageService {

  constructor() { }

  saveSelectedOrganization(organizationId: string, organizationName: string) {
    const o: OrganizationData = {
        id: organizationId,
        name: organizationName
    };
    sessionStorage.setItem('selectedOrganization', JSON.stringify(o));
  }

  getSelectedOrganization(): OrganizationData {
    const rawItem = sessionStorage.getItem('selectedOrganization');
    if (rawItem == null) { return null; }
    return JSON.parse(rawItem);
  }

  getSelectedRange(): {start: Date, end: Date} {
    const rawItem = sessionStorage.getItem('selectedRange');

    if (rawItem == null) {
      const start = moment().subtract(1, 'week').startOf('week');
      const end = moment().subtract(1, 'week').endOf('week');
      return { start: start.toDate(), end: end.toDate() };
    }

    const result = JSON.parse(rawItem);
    result.start = moment(result.start).toDate();
    result.end = moment(result.end).toDate();
    return result;
  }

  saveSelectedRange(start: Date, end: Date) {
    sessionStorage.setItem('selectedRange',
      JSON.stringify({
        start,
        end
      }));
  }
}
